<template>
  <div id="faces-detected">
    <div v-if="searching">
      <strong>Searching. Please wait...</strong>
    </div>
    <div v-if="!searching && (!faces || (faces.length && faces[0].merged_matches))">
            <h1>Potential Matches</h1>
    </div>
    <div v-if="faces && faces.length && !searching" class="faces-list">
      Click a picture to confirm. The number before the name is the match difference; smaller numbers are stronger matches.
      <div id="new-results" v-if="new_results && new_results > 0">
        Have {{new_results}} new result{{new_results > 1 ? 's' : ''}}. <a href="#/detected" v-on:click="updateResults">Refresh</a> to load.
      </div>
      <div v-for="face of faces" class="faces-list-entry" v-bind:key="face.runtime_face_uuid">
        <div class="faces-list-entry-info">
          <div class="camera-description">{{face.camera_description || face.camera_fname}}</div>
          <div claas="captured-at-diff">{{getTimeDiff(face.captured_at)}}</div>
          <div class="captured-at-string">{{getTimeString(face.captured_at)}}</div>
           <div>Confidence={{confidenceformat(face.face_confidence)}}</div> 
          <div>Face Height: {{face.face_height}}</div>
        </div>
        <div class="face-image-area">
          <a v-bind:href="face.frame_uri" target="_blank">
            <!-- <img :src="BASE_URL + '/api/v4/faceimage/' + face.runtime_face_uuid" height=144 class="the-image" /> -->
            <img :src="'https://yakov.owal.io/api/v6/faces/images/' + face.runtime_face_uuid + '?shape=1&clahe=1'" height=144 class="the-image" />
          </a>
        </div>
        <div v-if="face.merged_matches && face.merged_matches.length > 1" class="merged-matches-area">
          <!-- ... plus {{face.merged_matches.length - 1}} matches -->
          <img v-for="merged_match of face.merged_matches.slice(1,4)" :key="merged_match.runtime_face_uuid" :src="BASE_URL + '/api/v4/faceimage/' + merged_match.runtime_face_uuid" height=144 class="the-image" />
          <div v-if="face.merged_matches.length > 4">
            ... plus {{face.merged_matches.length - 4}} more
          </div>
        </div>
        <div v-if="face.matches && face.matches.length && (typeof not_match_filter[face.runtime_face_uuid] === 'undefined')" class="matches-area">
          <div v-for="potential_match of face.matches" class="potential-match" v-bind:key="potential_match.frontend_face_uuid">
            <img v-lazy="potential_match.image_uri" v-bind:height="face.matches.indexOf(potential_match) == 0 ? 160 : 120" v-bind:style="{border: (potential_match.is_exact || face.matches.indexOf(potential_match) == 0 ? 2 : 0) + 'px solid ' + (potential_match.is_exact ? 'green' : 'orange')}" v-on:click="faceMatchConfirm(face.runtime_face_uuid, potential_match.frontend_face_uuid, true)"/>
            <div class="potential-match-name-area">
              <div v-if="!potential_match.is_exact && potential_match.diff" id="circle" v-bind:style="{background: colorForMatch(potential_match.diff)}"></div>{{diffformat(potential_match.diff)}}&nbsp;
              <div v-if="!potential_match.is_exact && potential_match.confidence" id="circle" v-bind:style="{background: colorForMatchConfidence(potential_match.confidence)}"></div>&nbsp;{{confidenceformat(potential_match.confidence)}}&nbsp;
              <router-link v-bind:to="'/faces/' + potential_match.person_name" class="potential-match-name">{{potential_match.person_name}}</router-link>
            </div>
          </div>
        </div>
        <div v-if="typeof not_match_filter[face.runtime_face_uuid] !== 'undefined'" class="enter-name-area">
          <div class="enter-name-query-area">
            <div>Who is this?</div>
            <div>
              <input v-model="not_match_filter[face.runtime_face_uuid]">
            </div>
            <button class="ui button" v-on:click="visitor(face.runtime_face_uuid)">Visitor</button>
          </div>
          <div class="enter-name-matches-area">
            <div v-for="filtered_match of filteredMatches(face.runtime_face_uuid)" :key="filtered_match.frontend_face_uuid" class="enter-name-match">
              <img v-lazy="filtered_match.image_uri" height=120 v-on:click="faceMatchConfirm(face.runtime_face_uuid, filtered_match.frontend_face_uuid, true)"/>
              <div class="enter-name-match-name-area">
                <router-link v-bind:to="'/faces/' + filtered_match.person_name" class="enter-name-match-name">{{filtered_match.person_name}}</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="not-a-face-area" v-if="!face.merged_matches && typeof not_match_filter[face.runtime_face_uuid] === 'undefined' && !face.matches.find(x=>x.is_exact)">
          <p>
            <!-- <a v-on:click="notAFace(face.runtime_face_uuid)" href="#/detected">Not a face?</a> -->
            <button class="ui negative small basic button" v-on:click="notAFace(face.runtime_face_uuid)">Not a face</button>
          </p>
          <p>
            <button class="ui small button" v-on:click="notAMatch(face.runtime_face_uuid)">Person not listed?</button>
          </p>
        </div>
      </div>
      <infinite-loading :on-infinite="getMoreResults" ref="infiniteLoading" v-if="!$route.params.frontend_face_uuid"></infinite-loading>
    </div>
    <div v-if="!searching && faces && !faces.length">
      No results.
    </div>
    <div v-if="oldest_time">
      Showing results up to {{oldest_time}}
    </div>
    <div v-if="!searching && !loadingMore && $route.params.frontend_face_uuid">
      <button class="ui button" v-on:click="getMoreResults">Load More</button>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import momenttz from 'moment-timezone';
import InfiniteLoading from 'vue-infinite-loading';

import {facesdetected, faceimage, facematches, faceconfirm, facematchconfirm, facesearch, facesdetected2, facevisitor} from '../api/faces';
import {BASE_URL} from '../api/base';
import {mapGetters} from 'vuex';
import {confidenceformat, colorForMatchConfidence} from '../util/confidence';

export default {
  name: 'faces-detected',
  data: function() {
    return {
      faces: [],
      face_matches: {},
      searching: true,
      BASE_URL,
      new_results: 0,
      not_match_filter: {},
      batch_number: 0,
      loadingMore: false,
      oldest_time: '',
      refresh_token: '',
    }
  },
  watch: {
    '$route': function() {
      this.updateResults()
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateResults()
  },
  methods: {
    colorForMatchConfidence, confidenceformat,
    getMatches(runtime_face_uuid) {
      facematches(runtime_face_uuid).then(res => res.data).then(data => {
        if (!data.ok) {
          console.log(data.err);
          return;
        }
        const matches = data.matches;
        /*
        Sample response:
        {
          "ok": true,
          "matches": [
            {
              "frontend_face_uuid": "6ccea727-0673-4315-8d1d-2d5d5a342d67",
              "person_name": "Silvio Ortiz",
              "image_uri": "https://s3.amazonaws.com/owal-clips/faces/Silvio Ortiz.JPG",
              "diff": 0.5889765314668264
            },
            ...
          ]
        }
        */
        const first_five_matches = matches.slice(0, 5);

        this.$set(this.face_matches, runtime_face_uuid, first_five_matches);
        console.log(`Updated face_matches[${runtime_face_uuid}]`);
      })
    },
    getTimeDiff(time_str) {
      console.log(time_str);
      return moment.utc(time_str).fromNow();
    },
    getTimeString(time_str) {
      return moment.utc(time_str).tz('America/New_York').format("dddd, MMMM Do YYYY, h:mm:ss a");
    },
    colorForMatch(diff) {
      if (diff < 0.4) {
        return 'green';
      } else if (diff < 0.6) {
        return 'yellow';
      } else {
        return 'red';
      }
    },
    notAFace(runtime_face_uuid) {
      faceconfirm(runtime_face_uuid, false).then(res => res.data).then(data => {
        if (data.ok) {
          // alert("Got it, thanks!");
          // this.updateResults();
          const new_faces = this.faces;
          new_faces.splice(new_faces.findIndex(x => x.runtime_face_uuid === runtime_face_uuid), 1);
          this.faces = new_faces;
        } else {
          console.log(data.err);
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    notAMatch(runtime_face_uuid) {
      this.$set(this.not_match_filter, runtime_face_uuid, '');
    },
    diffformat(diff) {
      if (!diff) return ''; return diff.toFixed(2)
    },
    faceMatchConfirm(runtime_face_uuid, frontend_face_uuid, is_correct) {
      // const c = false;//confirm('a?');
      // if (!c) return;
      this.$set(this.not_match_filter, runtime_face_uuid, undefined);
      facematchconfirm(runtime_face_uuid, frontend_face_uuid, is_correct).then(res => res.data).then(data => {
        if (data.ok) {
          // alert("Got it, thanks!");
          // this.quietlyUpdateResults();
          const cur_runtime_det_obj_index = this.faces.findIndex(x => x.runtime_face_uuid === runtime_face_uuid);
          if (cur_runtime_det_obj_index == -1) {
            console.log('Could not find cur_runtime_det_obj. Refreshing.');
            this.updateResults();
            return;
          }
          const cur_runtime_det_obj = this.faces[cur_runtime_det_obj_index];
          const match_obj = cur_runtime_det_obj.matches.find(x => x.frontend_face_uuid === frontend_face_uuid);
          let frontend_match_obj;
          if (!match_obj) {
            console.log('Could not find match_obj. Searching in frontendFaces...');
            frontend_match_obj = this.frontendFaces.find(x => x.frontend_face_uuid === frontend_face_uuid);
          }
          if (!frontend_match_obj && !match_obj) {
            console.log(`Could not find match for frontend_face_uuid=${frontend_face_uuid} in runtime matches or frontendFaces. Refreshing...`);
            this.updateResults();
            return;
          }

          const new_faces = this.faces.slice();

          if (match_obj) {
            match_obj.is_exact = true;
            new_faces[cur_runtime_det_obj_index].matches = [match_obj];
          }
          if (frontend_match_obj) {
            const setme = {
              is_exact: true,
              person_name: frontend_match_obj.person_name,
              image_uri: (frontend_match_obj.images.find(y => y.orientation === 'front') || {}).thumbnail_uri
            };
            new_faces[cur_runtime_det_obj_index].matches = [setme];
          }
          this.faces = new_faces;
        } else {
          console.log(data.err);
        }
      }).catch((err) => {
        console.log(err)
      });
    },
    updateResults() {
      this.searching = true;
      const v1 = false;
      const v2 = true;
      if (v1) {
        let fun;
        if (this.$route.params.frontend_face_uuid) {
          fun = facesearch(this.$route.params.frontend_face_uuid);
        } else {
          fun = facesdetected();
        }
        fun.then(res => res.data).then(data => {
          if (!data.ok) {
            return alert(data.err);
          }
          this.faces = data.faces;
          this.faces.forEach(face => {
            this.getMatches(face.face_uuid);
          })
          this.searching = false;
        }).catch((err) => {
          console.log(err);
        })
      }
      if (v2) {
        // this.searching = true;
        const args = {};
        facesdetected2(this.$route.params.frontend_face_uuid).then(res => res.data).then(data => {
          if (!data.ok) {
            this.searching = false;
            return alert(data.err);
          }
          if (data.oldest_time) {
            this.oldest_time = moment.utc(data.oldest_time).fromNow()
          }
          this.faces = data.faces;
          this.searching = false;
          this.new_results = data.new_results || 0;
          this.refresh_token = data.refresh_token;
        }).catch((err) => {
          console.log(err);
        })
      }
    },
    getMoreResults() {
      // v2 only
      console.log(`Getting more results, offset=${this.faces.length}`);
      this.loadingMore = true;
      facesdetected2(this.$route.params.frontend_face_uuid, this.refresh_token).then(res => res.data).then(data => {
        if (!data.ok) {
          this.loadingMore = false;
          return alert(data.err);
        }
        this.faces = this.faces.concat(data.faces);
        this.new_results = data.new_results;
        this.batch_number = this.batch_number + 1;
        this.loadingMore = false;
        this.refresh_token = data.refresh_token;
        if (data.oldest_time) {
          this.oldest_time = moment.utc(data.oldest_time).fromNow()
        }
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      });
    },
    filteredMatches(runtime_face_uuid) {
      const filtertext = this.not_match_filter[runtime_face_uuid];
      let matches = [];
      if (!filtertext) {
        matches = this.frontendFaces;
      } else {
        matches = this.frontendFaces.filter(face => {
          if (face.person_name.toLowerCase().includes(filtertext.toLowerCase())) return true;
          // if ('employee'.startsWith(this.filtertext.toLowerCase()) && face.employee) return true;
          // if ('staff'.startsWith(this.filtertext.toLowerCase()) && face.employee) return true;
          // if ('resident'.startsWith(this.filtertext.toLowerCase()) && face.resident) return true;
          // if (face.room && face.room.toLowerCase().includes(this.filtertext.toLowerCase())) return true;
        })
      }
      return matches.slice(0, 5).map(x => {
        // need to get an image_uri - first image that's a frontal image
        if (!x.images || !x.images.length) return x;
        x.image_uri = (x.images.find(y => y.orientation === 'front') || {}).thumbnail_uri;
        return x;
      });
    },
    visitor(runtime_face_uuid) {
      facevisitor(runtime_face_uuid).then(res => res.data).then(data => {
        if (data.ok) {
          alert("Visitor added. Please refresh.");
        } else {
          alert(`Error marking visitor: ${err.message}`);
        }
      });
    }
  },
  updated() {
    // this.updateAllImages();
  },
  components: {
    InfiniteLoading,
  },
}
</script>

<style scoped>

a {
  color: black;
  text-decoration: underline;
}
a:hover {
  text-decoration: underline;
}

.faces-list {
  background-color: white;
  padding: 20px;
}

.faces-list-entry {
  border: 1px solid black; 
  margin: 10px 10px 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.faces-list-entry-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  /* border: 1px dashed blue;  */
}

.face-image-area {
  display: flex;
  flex-direction: column;
  margin: 0px;
  /* border: 1px dashed green; */
}

.the-image {
  /* border: 1px dashed orange; */
  margin-right: 1px;
}

.matches-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.potential-match {
  padding-left: 10px;
}

.camera-description {
  font-size: large;
}

.captured-at-diff {
  font-size: large;
}

.captured-at-string {
  font-size: small;
}

.potential-match-name-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.potential-match-name {
  padding-left: 10px;
}

.enter-name-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.enter-name-query-area {
  display: flex;
  flex-direction: column;
}

.enter-name-matches-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.enter-name-match {
  display: flex;
  flex-direction: column;
}

.enter-name-match-name-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

#circle {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: red;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// FacesDetected.vue?064b59d4